import { useRouter } from 'vue-router';

export default function useNavigate()
{
    const router = useRouter();

    /**
     * Handler for navigating to a different route.
     */
    class Navigate
    {
        dest = 'home';

        /**
         * @param {string} dest
         */
        constructor(dest)
        {
            this.dest = dest;
        }

        async handle()
        {
            router.push({ name: this.dest });
        }
    }

    return Navigate;
};
